import React from 'react';

const JS_History_2 = () => {
  return (
    <div >
      <h1>JS_History_2</h1>
      <p>Placeholder component for: "JS History"</p>
    </div>
  );
};

export default JS_History_2;
